function setCookie(key, value, exdays = 180, path = '/') {
  if (!key || !value) {
    throw new Error('Key or Value not defined');
  }

  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  const expires = `expires=${d.toUTCString()}`;
  const domain = '.elconmegarad.com';
  document.cookie = `${key}=${value}; ${expires}; domain=${domain}; path=${path}`;
}

export default function setVisitedCookie() {
  setCookie('landing_visited', true);
}



/** WEBPACK FOOTER **
 ** ./web/js/libs/visitedCookie.js
 **/